import { render } from "./App.vue?vue&type=template&id=20f3c327"
const script = {}

import "./App.vue?vue&type=style&index=0&id=20f3c327&lang=scss"
script.render = render

export default script